// @flow
import UniversalPaginationButton from './components/UniversalPaginationButton';
import SimpleCollapse from './components/SimpleCollapse';
import AddSvgIconSprite from './components/AddSvgIconSprite';
import WebLayout from './components/WebLayout';
import SubmenuToggle from './components/SubmenuToggle';
import FulltextHandler from './components/FulltextHandler';
import FooterHandler from './components/FooterHandler';
import GtmHandler from './components/GtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
import LazyImage from './components/LazyImage';
import ProductTypeSimpleCollapse from './components/ProductTypeSimpleCollapse';
import FilterContents from './components/FilterContents';
//import ExtendedFilters from './components/ExtendedFilters';
import CitationBox from './components/CitationBox';


// @flow e-shop
//import CategorySort                from './components/CategorySort';
//import MobileCategorySort          from './components/MobileCategorySort';

//ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
import EshopFulltextAutocomplete from './components/EshopFulltextAutocomplete';


// ESHOP: pokročilé funkce dlaždice
import EshopProductListTile from './components/EshopProductListTile';

export default (props) => {
    switch (props.decorator || props.is) {
        case 'AddSvgIconSprite':
            return AddSvgIconSprite;
        case 'WebLayout':
            return WebLayout;
        // case 'ContentChecker':
        //     return ContentChecker;
        case 'FooterHandler':
            return FooterHandler;
        case 'SimpleCollapse':
            return SimpleCollapse;
        case 'ProductTypeSimpleCollapse':
            return ProductTypeSimpleCollapse;
/*        case 'ExtendedFilters':
            return ExtendedFilters;*/
        case 'FilterContents':
            return FilterContents;
        // case 'GreedyMenu':
        //     return GreedyMenu;
        // case 'Typeahead':
        //     // COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
        //     return import('fg-frontend/components/Typeahead');
        // case 'Tabs':
        //     return Tabs;
        // case 'SelectDesign':
        //     return SelectDesign;
        case 'SubmenuToggle':
            return SubmenuToggle;
        case 'FulltextHandler':
            return FulltextHandler;
        // case 'FtQueryRetriever':
        //     return FtQueryRetriever;
        // case 'BasketTabs':
        //     return BasketTabs;
        // case 'PasswordToggle':
        //     // COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
        //     return import('fg-frontend/components/PasswordToggle');
        // case 'SocialShare':
        //     // COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
        //     return import('fg-frontend/src/components/SocialShare');
        // case 'Slider':
        //     return Slider;
        case 'UniversalPaginationButton':
            return UniversalPaginationButton;
        // case 'Tooltip':
        //     return Tooltip;
        case 'GtmHandler':
            return GtmHandler;
        case 'TriggerInViewport':
            return TriggerInViewport;
        // case 'PhotoSwipe':
        //     return PhotoSwipe;
        // case 'ContentSlider':
        //     return ContentSlider;
        case 'LazyImage':
            return LazyImage;
        // case 'Webslider':
        //     return Webslider;
        // case 'Countdown':
        //     return Countdown;
        // case 'Toggler':
        //     return Toggler;
        // case 'PrintPage':
        //     return PrintPage;
        // case 'FGUpload':
        //     // COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
        //     return import('./components/FGUpload');
        // case 'RangeSlider':
        //     return RangeSlider;
        // case 'FulltextResultsAnchors':
        //     return FulltextResultsAnchors;
        case 'CitationBox':
            return CitationBox;
        // case 'GoogleRecaptcha':
        //     // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
        //     return import('fg-frontend/src/components/GoogleRecaptcha');
        // case 'EshopPhotogallery':
        //     return EshopPhotogallery;
        // case 'EshopModel3D':
        //     // ESHOP: 3D model v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita 3D modelu (nastavitelne na fotogalerii))
        //     return import('fg-frontend/components/EshopModel3D');
        // case 'EshopImageZoom':
        //     return EshopImageZoom;
        // case 'EshopGalleryPopup':
        //     return EshopGalleryPopup;
        case 'EshopOrderForm':
            return import('fg-frontend/components/EshopOrderForm');
        case 'EshopFulltextAutocomplete':
            return EshopFulltextAutocomplete;
        // case 'ProductListSlider':
        //     return ProductListSlider;
        //
        // // eshop - detail produktu - komponenta productDetailVariantForm - odkomentovat, pokud je na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>
        // case 'EshopVariantStockHandler':
        //     return EshopVariantStockHandler;
/*        case 'CategorySort':
            return CategorySort;
        case 'MobileCategorySort':
            return MobileCategorySort;*/
        // case 'BranchPicker':
        //     return BranchPicker;
        // case 'EshopUserToolsHandler':
        //     // ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
        //     return import('./components/EshopUserToolsHandler');
        // case 'GoToCategory':
        //     return GoToCategory;
        case 'EshopProductListTile':
            return EshopProductListTile;
        case 'RadioSelect':
            // COMMON: Podpurna komponenta pro radio select group, ktera zpropaguje change eventu pro ucely PU (odeberte, pokud nepouzivate ve vypisu katalogu komponentu pro razeni ani komponenta pro prepnuti zobrazeni)
            return import('fg-frontend/src/components/RadioSelect');
        case 'CheckboxSelect':
            // COMMON: Komponenta pro podporu hromadneho zaskrtnuti ve skupine checkboxu (odeberte pokud nepouzivate ve vypisech produktu komponenty pro checkboxovou filtraci tagFilter, brandFilter, parameterFilter)
            return import('fg-frontend/src/components/CheckboxSelect');
        case 'FilterOfFilter':
          // ESHOP: Komponenta pro filtraci hodnot ve filtracni komponente
          return import('./components/FilterOfFilter');
        case 'FilterHandler':
          // ESHOP: Handler filtrace
          return import('./components/FilterHandler');
        // case 'NumberInput':
        //     // COMMON Komponenta pro nastaveni ciselneho mnozstvi (odeberte, pokud v projektu neni nakupni proces)
        //     return import('fg-frontend/components/NumberInput');
        // case 'ListToggle':
        //     // COMMON: Komponenta pro skryti/zobrazeni casti seznamu (odeberte pokud nepouzivate Nejprodavanejsi produkty ve vypisu produktu, ani vypis parametru v detailu produktu, ani nemate v projektu nakupni proces)
        //     return import('fg-frontend/components/ListToggle');
        // case 'RangeDatepicker':
        //     // COMMON: Komponenta intervaloveho datepickeru (odeberte, pokud nepouzivate Objednavky v B2B rezimu, nebo Faktury)
        //     return import('fg-frontend/components/RangeDatepicker');
        // case 'AnchorsList':
        //     // COMMON: Zalozkovy seznam s kotvami (odeberte, pokud nepouzivate v detailu produktu)
        //     return import('fg-frontend/src/components/AnchorsList');
        case 'RadioSelectTab':
             // COMMON: Komponenta pro zobrazeni skupiny radio buttonu formou zalozek (odeberte, pokud nepouzivate vychozi komponentu pro razeni produktu)
             return import('fg-frontend/src/components/RadioSelectTab');
        // case 'ShareUrl':
        //     // COMMON: Komponenta, ktera zkopiruje danou URL, resp. string do schranky (odeberte, pokud nepouzivate funkci Ziskat odkaz v detailu produktu ani Sdileni kosiku)
        //     return import('fg-frontend/src/components/ShareUrl');
        // case 'PrintPdf':
        //     // COMMON: Komponenta, ktera zajistuje tisk PDF (odeberte, pokud nepouzivate Faktury)
        //     return import('fg-frontend/src/components/PrintPdf');
        // case 'RedirectToUrl':
        //     // COMMON: Komponenta, ktera zajistuje presmerovani po casovem intervalu (odeberte, pokud nepouzivate zadnou platebni branu)
        //     return import('fg-frontend/src/components/RedirectToUrl');
         case 'Form':
             // COMMON: Komponenta pro osetreni HTML formu (odeberte, pokud nepouzivate vyber variant ve vypisu produktu ani objednavkovy pruvodce)
             return import('fg-frontend/src/components/Form');
        // case 'FileInput':
        //     // COMMON: Komponenta pro vlozeni jedineho souboru (odeberte, pokud nepouzivate Import objednavky z CVS)
        //     return import('fg-frontend/src/components/FileInput');
        default:
            console.log(`Unknown component ${props.decorator || props.is}`);
            return null;
    }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureBrandComponents.js